import type { ExamineeRegistrationType } from '@exam-center/graphql';
import { Label, LabelColor } from '@shared/components';

export type RegistrationTypeLabelVariants = ExamineeRegistrationType;

export const REGISTRATION_TYPE_COLOR: Readonly<Record<RegistrationTypeLabelVariants, LabelColor>> =
  {
    DIP_CHIP: LabelColor.SUCCESS,
    ATTACHMENTS: LabelColor.INFO,
  };

export const REGISTRATION_TYPE_TEXT: Readonly<Record<RegistrationTypeLabelVariants, string>> = {
  DIP_CHIP: 'Dip Chip',
  ATTACHMENTS: 'เอกสารอื่น',
};

interface RegistrationTypeLabelProps {
  variant: RegistrationTypeLabelVariants;
}

export default function RegistrationTypeLabel(props: Readonly<RegistrationTypeLabelProps>) {
  const { variant } = props;

  return (
    <Label
      color={REGISTRATION_TYPE_COLOR[variant]}
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(1.5),
        p: theme.spacing(1, 3),
      })}
    >
      {REGISTRATION_TYPE_TEXT[variant]}
    </Label>
  );
}
